import { render, staticRenderFns } from "./ExpenseDashboard.vue?vue&type=template&id=6255cde4&scoped=true"
import script from "./ExpenseDashboard.vue?vue&type=script&lang=js"
export * from "./ExpenseDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6255cde4",
  null
  
)

export default component.exports